import {Component, inject, Input, Signal} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {MatGridListModule} from '@angular/material/grid-list';
import {MovementTypes, RankingsList, RankingTableEntry} from './rankingsList.interface';
import {CommonModule} from '@angular/common';
import {ShareButtonModule} from 'ngx-sharebuttons/button';
import {faCaretUp, faCaretDown, faCaretRight, faStar} from '@fortawesome/free-solid-svg-icons';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs';
import {rankingsTableRowSizer, rankingsTitleRowSizer, rowSizer} from '../../dahsboard.utils';
import {MediaQueryService} from '../../../../services/media-query/media-query.service';
import {IconProp} from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-rankings',
  templateUrl: './rankings.component.html',
  styleUrls: ['./rankings.component.scss'],
  imports: [
    MatCardModule,
    MatDividerModule,
    MatGridListModule,
    ShareButtonModule,
    CommonModule
  ],
  standalone: true
})
export class RankingsComponent {
  @Input() rankingsList: RankingTableEntry[] = [];
  private mediaService: MediaQueryService = inject(MediaQueryService);

  public caretUpIcon = faCaretUp as IconProp;
  public caretDownIcon = faCaretDown as IconProp;
  public caretRightIcon = faCaretRight as IconProp;
  public starIcon = faStar as IconProp;

  public titleRowSizer: Signal<string> = toSignal(this.mediaService.getDisplayType().pipe(map(rankingsTitleRowSizer)), {initialValue: '0'});
  public tableRowSizer: Signal<string> = toSignal(this.mediaService.getDisplayType().pipe(map(rankingsTableRowSizer)), {initialValue: '0'});

  iconLookup(icon: MovementTypes): IconProp {
    switch (icon) {
      case 'up':
        return this.caretUpIcon;
      case 'down':
        return this.caretDownIcon;
      case 'equal':
        return this.caretRightIcon;
      default:
        return this.starIcon;
    }
  }

  colorLookup(icon: MovementTypes): string {
    switch (icon) {
      case 'up':
        return 'increasing';
      case 'down':
        return 'decreasing';
      case 'equal':
        return 'noMovement';
      default:
        return 'newEntry';
    }
  }

  textLookup(icon: MovementTypes): string {
    switch (icon) {
      case 'up':
        return 'Up';
      case 'down':
        return 'Down';
      case 'equal':
        return 'No Move';
      default:
        return 'New Entry';
    }
  }
}
